class OrderDelivery {
    // constructor() {
    //     this.delivery = document.querySelector('.js-delivery');
    //
    //     this.init();
    // }
    //
    // init = () => {
    //     this.delivery.addEventListener('click', this.deliveryMethodClick)
    // }
    //
    // deliveryMethodClick = async (e) => {
    //     e.preventDefault();
    //
    //     const target = e.target.closest('[data-delivery-method]');
    //
    //     if (!target) return;
    //
    //     const method = target.dataset.deliveryMethod;
    //
    //     await this.openModal(method);
    // }
    //
    // openModal = async () => {
    //     const saveButton = document.querySelector('.js-order-delivery-address-save');
    //
    //     saveButton && saveButton.addEventListener('click', this.handleSaveClick);
    // }
    //
    // handleSaveClick = (e) => {
    //     e.preventDefault();
    //
    //     modals.closeModal(null, '#order-delivery');
    //
    //     document.dispatchEvent(new CustomEvent('order:selectAddress', {
    //         detail: {
    //             address: {
    //                 city: 'test1',
    //                 street: '',
    //                 house: '',
    //                 building: '',
    //                 entrance: '',
    //                 floor: '',
    //                 apartment: '',
    //             },
    //             saveAddress: false,
    //         }
    //     }))
    // }
}
